import { render } from "./ChildPage.vue?vue&type=template&id=9b8f7b74"
import script from "./ChildPage.vue?vue&type=script&lang=js"
export * from "./ChildPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__